// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function authReducer(state = false, action) {
    switch (action.type) {
        case types.LOGOUT:
            return false;
        case types.LOGIN_SUCCESS: case types.SILENT_LOGIN:
            return true;
        case types.LOGIN_FAILURE:
            return false;
        default:
            return state;
    };
};
